import React from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import styles from './BinderNavigation.scss';
import {Tabs} from 'components/common/Tabs/Tabs';
import { GoBack } from 'components/common/Link';
import { Button, BUTTON } from 'components/common/Button/Button';
import { requestBinderExport } from '../../../common/actions/binderExportActions';
const { SIZE, COLOR, BGCOLOR } = BUTTON;

function BinderNavigation ({ title , location, tabs, fixedNav, hasMaxWidth, homeRoute, isStudy, binderId, requestBinderExport, hasDownloadBindersPermission, isRequestingExport }){
    const binderNavStyle = fixedNav ? styles.stuckBinderNavContainer : styles.binderNavigationContainer;
    const binderNavMaxWidthClass = hasMaxWidth ? styles.maxWidthModifier: '';
    const type = isStudy ? 'Studies' : 'Binders';
    
    const handleDownloadBinder = () => {
        if (binderId && !isRequestingExport) {
            requestBinderExport(binderId);
        }
    };
    
    return(
        <div className={`${binderNavStyle} ${binderNavMaxWidthClass}`} data-cy="binderNavigation">
            <GoBack
                data-test-id='hyp-binder-navigation-back'
                to={homeRoute}
            >
                Back to {type} List
            </GoBack>
            <div className={styles.binderHeader}>
                <div className={styles.binderTitle}>
                    {title}
                </div>
                {hasDownloadBindersPermission && (
                    <Button
                        text={'Download Binder'}
                        type={SIZE.PRIMARY}
                        color={COLOR.BLACK}
                        bgcolor={BGCOLOR.CLEAR}
                        outline={BUTTON.OUTCOLOR.GREY}
                        onClick={handleDownloadBinder}
                        disabled={isRequestingExport}
                        data-cy="DownloadSingleBinderButton-3.0"
                    />
                )}
            </div>
            <Tabs tabs={tabs} location={location} />
        </div>
    );
}

export default connect(
    (state) => {
        // Check if user has the "Download Binders" system permission
        const hasDownloadBindersPermission = lodash.get(state, 'me.systemPermissions.downloadBinders', false);
        const isRequestingExport = lodash.get(state, 'binderExport.isRequesting', false);
        return {
            hasDownloadBindersPermission,
            isRequestingExport
        };
    },
    {
        requestBinderExport
    }
)(BinderNavigation);

